"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getKeyFromState_1 = require("../helpers/getKeyFromState");
const sessionZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/sessionZeroState"));
function nonExistingNonRootZeroStatesOfILT(content, user, existingStates) {
    const existingStatesDictionary = {};
    existingStates.forEach((existingState) => (existingStatesDictionary[getKeyFromState_1.getKeyFromState(existingState)] = 1));
    const states = [];
    if (content.meta && content.meta.sessions) {
        content.meta.sessions.forEach((session) => {
            if (!existingStatesDictionary[getKeyFromState_1.getKeyFromContentAndUser(user, session)]) {
                const state = sessionZeroState_1.default(session, user, content);
                states.push(state);
            }
        });
    }
    return states;
}
exports.nonExistingNonRootZeroStatesOfILT = nonExistingNonRootZeroStatesOfILT;
//# sourceMappingURL=nonExistingNonRootZeroStatesOfILT.js.map